import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  RESET,
  SET_DEFAULT_VALUE,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    benefitAreYouClaimingFor: '',
    assistance: '',
    nameOfDeceased: '',
    dateApproved: '',
    causeOfDeath: '',
    dateOfDeath: '',
    stateOfDeath: '',
    countryOfDeath: '',
    wasTheMemberHospitalized: '',
    fromDate: '',
    toDate: '',
    nameOfFuneralServiceProvider: '',
    costOfLocalBurial: '',
    invoice: '',
    amountClaimed: '',
    costOfLocalBurialCurrency: '',
    amountClaimedCurrency: '',
    familyMemberProvidingInformation: '',
    relationshipToMember: '',
    address: '',
    cityOrTown: '',
    country: '',
    postalCode: '',
  },
});

function step17Reducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case SET_DEFAULT_VALUE: {
      return state.setIn(properties, action.value);
    }
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case RESET:
      return initialState;
    default:
      return state;
  }
}

export default step17Reducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step17/reducer.js